export default __webpack_public_path__ + "static/media/cup.16e6df06.png";